import { BrowserRouter } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { Route } from 'react-router-dom';
import './App.css';
import Home from './pages/home';
import DashboardPage from './pages/dashboard';
import CoinPage from './pages/coin';
import ComparePage from './pages/compare';
import WatchListPage from './pages/watchlist';
import SignalsPage from './SignalsPage';
//import NewTokensPage from './pages/NewTokens'
import OverviewPage from "./pages/OverviewPage";
import VisionPage from "./pages/VisionPage";
import SignalFeedPage from "./pages/SignalFeedPage";
import SignalAnatomy from "./pages/SignalAnatomy";
import SignalInfrastructure from "./pages/SignalInfrastructure";
import SmartMoneyPage from "./pages/SmartMoneyPage";
import RawSignalsPage from "./pages/RawSignalsPage";
import BehaviorPage from "./pages/BehaviorPage";
import BehaviorDeepPage from "./pages/BehaviorDeepPage";
import AnomalyPage from "./pages/AnomalyPage";
import ClusterPage from "./pages/ClusterPage";
import GraphPage from "./pages/GraphPage";
import EventFlow from "./pages/EventFlow";
import MultiPulsePage from "./pages/MultiPulsePage";
import AutoTradingPage from "./pages/AutoTradingPage";
import ClassicMarketTrackerPage from "./pages/ClassicMarketTrackerPage";
import LiveSignalCenterPage from "./pages/LiveSignalCenterPage";
import TokenRiskPage from "./pages/TokenRiskPage";
import BotLabPage from "./pages/BotLabPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/market-tracker-classic" element={<ClassicMarketTrackerPage />} />
        <Route path="/coin/:id" element={<CoinPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/feed" element={<SignalFeedPage />} />
        <Route path="/signal-center" element={<LiveSignalCenterPage />} />
        <Route path="/token-risk" element={<TokenRiskPage />} />
        <Route path="/signal-anatomy" element={<SignalAnatomy />} />
        <Route path="/signal-engine" element={<SignalInfrastructure />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/watchlist" element={<WatchListPage />} />
        <Route path="/signals" element={<SignalsPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/smart-money" element={<SmartMoneyPage />} />
        <Route path="/raw" element={<RawSignalsPage />} />
        <Route path="/anomaly" element={<AnomalyPage />} />
        <Route path="/clusters" element={<ClusterPage />} />
        <Route path="/behavior" element={<BehaviorPage />} />
        <Route path="/behavior-deep" element={<BehaviorDeepPage />} />
        <Route path="/event-flow" element={<EventFlow />} />
        <Route path="/pulse" element={<MultiPulsePage />} />
        <Route path="/auto-trading" element={<AutoTradingPage />} />
        <Route path="/bot-lab" element={<BotLabPage />} />
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
